import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SigninView from './components/auth/Signin/SigninView';
import SignupView from './components/auth/Signup/SignupView';
import SignupWithEmailPassword from './components/auth/Signup/SignupWithEmailPassword';
import SigninWithEmailView from './components/auth/SigninWithEmail/SigninWithEmailView';
import ForgotPasswordView from './components/auth/ForgotPassword/ForgotPasswordView';
import ResetPasswordView from './components/auth/ResetPassword/ResetPasswordView';
import HomeTabs from './components/home/HomeTabs/HomeTabs';
import PostDetails from './components/home/PlaygroundTab/Post/PostDetails';
import ProfileDetails from './components/home/ProfileTab/ProfileDetails';
import SuccessfullyApplied from './components/home/PlaygroundTab/Post/SuccessfullyApplied';
import MessagesTab from './components/home/MessagesTab/MessagesTab';
import MyApplicationsReferral from './components/Referrals/MyApplicationsReferral';
import './App.css';
import { PlaygroundProvider } from './contexts/PlaygroundContext';
import SignupSetUsernameAndBio from './components/auth/Signup/SignupSetUsernameAndBio';
import PolicyComponent from './components/common/PolicyComponent/PolicyComponent';
import { initTikTokPixel } from './utils/tiktokPixel';

const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const isAuthenticated = !!localStorage.getItem('accessToken');
  return isAuthenticated ? element : <Navigate to="/signin" replace />;
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize TikTok Pixel
    initTikTokPixel();

    const updateAppHeight = () => {
      const appHeight = window.innerHeight;
      document.documentElement.style.setProperty('--app-height', `${appHeight}px`);
    };

    window.addEventListener('resize', updateAppHeight);
    updateAppHeight();

    return () => window.removeEventListener('resize', updateAppHeight);
  }, []);

  return (
    <PlaygroundProvider>
      <div className="app-container">
        <Router>
          <React.Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/signin" element={<SigninView />} />
              <Route path="/signup" element={<SignupView />} />
              <Route path="/signup_email" element={<SignupWithEmailPassword />} />
              <Route path="/signup/profile" element={<SignupSetUsernameAndBio />} />
              <Route path="/signin_email" element={<SigninWithEmailView />} />
              <Route path="/forgot_password" element={<ForgotPasswordView />} />
              <Route path="/reset_password" element={<ResetPasswordView />} />
              <Route path="/posts/:postSlug" element={<PostDetails />} />
              <Route path="/profile/:username" element={<ProfileDetails />} />
              <Route path="/successfully-applied" element={<SuccessfullyApplied />} />
              <Route path="/add-referrals" element={<ProtectedRoute element={<MyApplicationsReferral />} />} />
              <Route element={<ProtectedRoute element={<HomeTabs />} />}>
                <Route path="/playground" element={null} />
                <Route path="/search" element={null} />
                <Route path="/activity" element={null} />
                <Route path="/profile" element={null} />
                <Route path="/messages" element={null} />
                <Route path="*" element={<Navigate to="/playground" replace />} />
              </Route>
              <Route path="/privacy" element={<PolicyComponent type="privacy" />} />
              <Route path="/tos" element={<PolicyComponent type="tos" />} />
            </Routes>
          </React.Suspense>
        </Router>
      </div>
    </PlaygroundProvider>
  );
};

export default App;
